<template>
    <Paper class="favorite-card-root">
        <div
            class="pointer p-4 d-flex flex-column align-items-center"
            @click="goToJob"
            v-if="data.job"
        >
            <div class="image-wrapper">
                <img class="image" :src="logo" />
            </div>
            <h6 class="text-center subtitle mt-2 mb-1">{{ title() }}</h6>
            <div class="flex-grow" />
            <!--  <p class='text-center caption mute mb-2'>{{ address() }}</p> -->
            <p class="text-center caption mute">
                {{ $t('shared.postingModule.postCard.deadline') }}
                {{ deadline() }}
            </p>
        </div>
        <div
            v-else
            class="banner-root d-flex flex-column-reverse align-items-center"
        >
            <div
                class="banner d-flex align-items-center justify-content-center"
            >
                <h6 class="white mb-0 heading">
                    {{ $t('shared.favoriteModule.favoriteCard.deleted') }}
                </h6>
            </div>
            <div>
                <p class="caption mute text-center">
                    {{ $t('shared.favoriteModule.favoriteCard.deletedTitle') }}
                </p>
            </div>
        </div>
    </Paper>
</template>

<script>
import dateToString from '~/utils/dateToString';

export default {
    name: 'FavoriteCard',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        logo() {
            return this.job().companyLogo || null;
        },
    },
    methods: {
        goToJob() {
            let jobId = null;
            if (this.data.job) {
                jobId = this.data.job.id;
            } else {
                jobId = ''.concat(this.data.jobAdId, '?isJobAdId=true');
            }
            this.$router.push(this.$URLS.jobDetail.concat('/', jobId));
        },
        job() {
            return this.data.job || {};
        },
        title() {
            return this.job().title || null;
        },
        address() {
            return this.job().address || null;
        },
        deadline() {
            return this.data.job ? dateToString(this.job().deadline) : null;
        },
    },
};
</script>

<style scoped>
.favorite-card-root:hover {
    box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.15) !important;
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
}

.image-wrapper {
    max-width: 200px;
    max-height: 100px;
    height: 100px;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    max-height: 100px;
    object-fit: scale-down;
}

.banner-root {
    position: relative;
    min-height: 200px;
    overflow: hidden;
}

.banner {
    position: absolute;
    right: -30px;
    left: -30px;
    top: 30%;
    height: 46px;
    color: white;

    background-color: var(--primary);

    transform: rotateZ(-10deg);
}
</style>
